import { render, staticRenderFns } from "./tablaClientes.vue?vue&type=template&id=cbca74b4&scoped=true&"
import script from "./tablaClientes.vue?vue&type=script&lang=js&"
export * from "./tablaClientes.vue?vue&type=script&lang=js&"
import style0 from "./tablaClientes.vue?vue&type=style&index=0&id=cbca74b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbca74b4",
  null
  
)

export default component.exports